/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { BinderClaimResponseDto } from './BinderClaimResponseDto';
import {
    BinderClaimResponseDtoFromJSON,
    BinderClaimResponseDtoFromJSONTyped,
    BinderClaimResponseDtoToJSON,
    BinderClaimResponseDtoToJSONTyped,
} from './BinderClaimResponseDto';

/**
 * 
 * @export
 * @interface BinderClaimPaginationResponseDto
 */
export interface BinderClaimPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof BinderClaimPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<BinderClaimResponseDto>}
     * @memberof BinderClaimPaginationResponseDto
     */
    items: Array<BinderClaimResponseDto>;
}

/**
 * Check if a given object implements the BinderClaimPaginationResponseDto interface.
 */
export function instanceOfBinderClaimPaginationResponseDto(value: object): value is BinderClaimPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BinderClaimPaginationResponseDtoFromJSON(json: any): BinderClaimPaginationResponseDto {
    return BinderClaimPaginationResponseDtoFromJSONTyped(json, false);
}

export function BinderClaimPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderClaimPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(BinderClaimResponseDtoFromJSON)),
    };
}

export function BinderClaimPaginationResponseDtoToJSON(json: any): BinderClaimPaginationResponseDto {
    return BinderClaimPaginationResponseDtoToJSONTyped(json, false);
}

export function BinderClaimPaginationResponseDtoToJSONTyped(value?: BinderClaimPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(BinderClaimResponseDtoToJSON)),
    };
}

